import { FETCH_COUNTRIES_LIST } from "../types";

export const countriesDataReducer = (
  state = { isLoading: true, data: [] },
  action: { type: any; payload: any }
) => {
  switch (action.type) {
    case FETCH_COUNTRIES_LIST:
      return {
        isLoading: false,
        data: action.payload,
      };
    default:
      return state;
  }
};
